import cn from 'classnames'
import { Icon } from '../../icon'
import { Typography } from '../../typography'
import styles from './PasswordHelperRules.module.css'
import { PasswordHelperRulesProps } from './PasswordHelperRules.types'

export function PasswordHelperRules({ rules }: PasswordHelperRulesProps) {
  return (
    <div className={styles.helperRules} aria-live="polite">
      {rules.map(column => (
        <ul key={column[0]?.text} className={styles.helperColumn}>
          {column.map((rule) => {
            const isSatisfied = rule.status === 'satisfied'

            return (
              <li key={rule.text} className={cn(styles.rule, isSatisfied ? styles.ruleSatisfied : styles.ruleUnsatisfied)}>
                <Icon size={16} glyph={isSatisfied ? 'CheckMarkSmall' : 'CircleFilledExtraSmall'} aria-hidden />
                <Typography variant="body-s-regular-tight" className={styles.ruleText}>
                  {rule.text}
                </Typography>
              </li>
            )
          })}
        </ul>
      ))}
    </div>
  )
}
